/* plantas finas — Gewaehrleistungslabel im Bestellweg sicherstellen

   Pflicht seit 27.09.2026, Durchfuehrungsverordnung (EU) 2025/1960.
   Das Label muss vor Abgabe der Vertragserklaerung direkt als Grafik zu
   sehen sein, in einer Groesse, die man ohne Zoomen lesen kann — und
   vollstaendig, nicht angeschnitten.

   ================================================================
   WARUM DIESE DATEI NOETIG IST
   ================================================================
   Auf der Warenkorbseite steht das Label serverseitig
   (snippets/pf-gewaehrleistungslabel.liquid, bis 820 px breit). Die
   Warenkorb-Schublade ist dagegen eine reine JavaScript-Komponente, die
   Dawn bei jeder Aenderung neu aufbaut — dort geht es nur so.

   ================================================================
   WANN DAS LABEL IN DIE SCHUBLADE KOMMT
   ================================================================
   Dawns Schublade ist:  width: 40rem;  max-width: calc(100vw - 3rem)
   Also 400 px, gedeckelt auf Fensterbreite minus 30 px. Auf einem Telefon
   ist sie damit genauso breit wie die Warenkorbseite, auf dem Desktop nur
   ein Drittel davon.

   FEHLER 1 (behoben 28.09.2026): Hier stand eine feste Grenze von 430 px,
   formuliert als "kleiner als 430". Ein iPhone 15 Pro Max meldet exakt 430
   — auf genau diesen Geraeten fiel das Label heraus. Jetzt wird gemessen
   statt geraten: Bietet die Schublade mindestens neunzig Prozent dessen,
   was die Warenkorbseite boete, bleibt der Kunde dort und geht direkt zur
   Kasse. Sonst fuehrt der Knopf ueber die Warenkorbseite.

   FEHLER 2 (behoben 28.09.2026): Das Label wurde unten angeschnitten.
   Dawns Schublade hat feste Hoehe und overflow: hidden; sobald der Fuss
   waechst, quetscht die Artikelliste auf null und der Rest laeuft unten
   heraus, ohne dass man scrollen kann. Deshalb bekommt .drawer__inner die
   Klasse pf-gl-scroll, sobald das Label darin steckt — die Schublade wird
   dann zu einer gewoehnlich scrollbaren Spalte. Das CSS dazu steht in
   assets/pf-gewaehrleistungslabel.css.

   ================================================================
   ACHTUNG BEI AENDERUNGEN
   ================================================================
   Die Bild-Adresse steht hier UND in
   snippets/pf-gewaehrleistungslabel.liquid. Wird das Label je gegen eine
   neue amtliche Fassung getauscht, beide Stellen aendern.

   Nicht erlaubt waere es, das Label hinter einen Link, ein Icon oder ein
   Aufklapp-Element zu legen. Es muss unmittelbar dastehen. */

(function () {
  'use strict';

  var QUELLE =
    'https://cdn.shopify.com/s/files/1/0952/4133/9261/files/gewaehrleistungslabel-de.png?v=1790592867';

  /* Ab welchem Anteil der Seitenbreite die Schublade als gleichwertig gilt.
     0.9 heisst: Bis zu zehn Prozent schmaler ist in Ordnung — dafuer lohnt
     kein zusaetzlicher Klick. */
  var ANTEIL = 0.9;

  var ALT =
    'Gesetzliche Gewährleistung: Mindestens zwei Jahre gesetzliche ' +
    'Gewährleistung der Vertragsmäßigkeit für Waren, die in der ' +
    'Europäischen Union verkauft werden. Harmonisierte Mitteilung der ' +
    'Europäischen Union.';

  var kachel = null;

  function fensterbreite() {
    return document.documentElement.clientWidth || window.innerWidth || 0;
  }

  /* Platz auf der Warenkorbseite: page-width ist auf 1200 px begrenzt,
     abzueglich 1,5 rem Innenabstand je Seite. */
  function platzSeite() {
    return Math.min(fensterbreite() - 30, 1200);
  }

  /* Platz in der Schublade: wenn moeglich gemessen statt gerechnet, damit
     spaetere Aenderungen an Dawns CSS hier nicht unbemerkt danebenliegen. */
  function platzSchublade() {
    var innen = document.querySelector('#CartDrawer .drawer__inner');
    if (innen && innen.clientWidth) return innen.clientWidth - 30;
    return Math.min(400, fensterbreite() - 30) - 30;
  }

  function schubladeReicht() {
    var s = platzSchublade();
    return s > 0 && s >= platzSeite() * ANTEIL;
  }

  function bauen() {
    var d = document.createElement('div');
    d.className = 'pf-gl pf-gl--schublade';
    var img = document.createElement('img');
    img.className = 'pf-gl-bild';
    img.src = QUELLE + '&width=820';
    img.width = 1654;
    img.height = 2339;
    img.alt = ALT;
    img.loading = 'eager';
    img.decoding = 'async';
    d.appendChild(img);
    return d;
  }

  function scrollModus(an) {
    var innen = document.querySelector('#CartDrawer .drawer__inner');
    if (!innen) return;
    innen.classList.toggle('pf-gl-scroll', !!an);
  }

  function abraeumen() {
    if (kachel && kachel.parentElement) kachel.parentElement.removeChild(kachel);
    scrollModus(false);
  }

  function einhaengen() {
    var fuss = document.querySelector('#CartDrawer .drawer__footer');
    if (!fuss) return;
    if (!schubladeReicht() || document.querySelector('cart-drawer.is-empty')) {
      abraeumen();
      return;
    }
    if (!kachel) kachel = bauen();
    if (kachel.parentElement !== fuss) fuss.appendChild(kachel);
    scrollModus(true);
  }

  /* Der Knopf fuehrt nur dann ueber die Warenkorbseite, wenn das Label in
     der Schublade fehlt. Sonst direkt zur Kasse — kein Klick zu viel. */
  document.addEventListener(
    'click',
    function (e) {
      if (!e.target || !e.target.closest) return;
      if (!e.target.closest('#CartDrawer-Checkout')) return;
      if (schubladeReicht()) return;
      e.preventDefault();
      e.stopPropagation();
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
    },
    true
  );

  function beschriften() {
    var knopf = document.querySelector('#CartDrawer-Checkout');
    if (!knopf) return;
    var soll = schubladeReicht() ? 'Auschecken' : 'Weiter zum Warenkorb';
    if (knopf.textContent.trim() !== soll) knopf.textContent = soll;
  }

  function auffrischen() {
    einhaengen();
    beschriften();
  }

  function start() {
    var schublade = document.querySelector('cart-drawer');
    if (!schublade) return;
    auffrischen();
    if (typeof MutationObserver === 'function') {
      new MutationObserver(auffrischen).observe(schublade, {
        childList: true,
        subtree: true
      });
    }
    window.addEventListener('resize', auffrischen, { passive: true });
    window.addEventListener('orientationchange', auffrischen);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
